import styled from 'styled-components';

export const Underline = styled.div`
  width: 5rem;
  height: 0.3rem;
  background: ${({ light }) => (light ? '#fff' : '#8d8d8d')};
  margin: 0.5rem auto;
  margin-bottom: 64px;
`;
